import * as React from 'react';

import * as colors from '../../shared/colors';
import t from '../../shared/translations';

interface IProps {
    color?: string;
}

function OpenChatButton({ color }: IProps): JSX.Element {
    const style: React.CSSProperties = {
        backgroundColor: color ?? colors.primaryColor,
    };
    const open = () => {
        const event = new Event('tm-open-chat');
        document.querySelector('body').dispatchEvent(event);
    };
    return <button style={style} type='button' onClick={open}>{t('player.chat.button-open-chat')}</button>;
}

export default OpenChatButton;
